import { render, staticRenderFns } from "./ApproveClueApply.vue?vue&type=template&id=5ca8c95c&scoped=true"
import script from "./ApproveClueApply.vue?vue&type=script&lang=js"
export * from "./ApproveClueApply.vue?vue&type=script&lang=js"
import style0 from "./ApproveClueApply.vue?vue&type=style&index=0&id=5ca8c95c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8c95c",
  null
  
)

export default component.exports